<template>
  <div class="main" v-loading="loading">
    <div class="hot-title">
      <dl>
        <dd @click="check(1)" :class="[timeActive === 1 ? 'active' : '']">
          实时热文
        </dd>
      </dl>
    </div>
    <div id="wxTable" class="listTable">
      <div v-for="(item, indexList) in getData" :key="indexList">
        <div class="lineBox"></div>
        <div class="main-box">
          <div>
            <a href="javascrip:;" @click="jump(item.resourceGuid)"
              ><img :src="imageShowUrl(item.coverImage)" @error="imgError(item)"
            /></a>
          </div>
          <div style="width: 100%;">
            <div class="title" :title="item.title">
              <a href="javascrip:;" @click="jump(item.resourceGuid)">{{
                item.title
              }}</a>
            </div>
            <div class="user">
              <span class="head-img"
                ><img
                  :src="
                    item.headImage
                      ? item.headImage
                      : '//favorite.5ceimg.com/author/cfa9837c-5f31-e811-8dac-c81f66ed8109.png!24_24'
                  "
              /></span>
              {{ item.name ? item.name : "知乎用户" }}
            </div>
            <div class="count">
              <div>{{ item.issueTime | changeTime() }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-pagination
      background
      layout="prev, pager, next, jumper"
      :total="rowCount"
      :current-page="pageable.pageIndex"
      :page-size="pageable.pageSize"
      :pager-count="5"
      @current-change="goPage"
      hide-on-single-page
    ></el-pagination>
  </div>
</template>

<script>
import { Pageable } from "../../assets/script/model";
import { mapActions } from "vuex";

export default {
  name: "WeiXinList",
  data() {
    return {
      timeActive: 1,
      loading: false,
      rowCount: 0,
      getData: []
    };
  },
  computed: {
    contentHeight: {
      get() {
        return this.$store.state.contents.contentHeight;
      },
      set(val) {
        this.$store.state.contents.contentHeight = val;
      }
    },
    pageable: {
      get() {
        return this.$store.state.hotList.Pageable;
      },
      set(val) {
        this.$store.state.hotList.Pageable = val;
      }
    }
  },
  watch: {
    contentHeight: {
      handler(val) {
        this.getHotLineHeight(val, "wxTable", 35);
      }
    }
  },
  created() {
    this.getData = [];
    this.pageable = new Pageable(1, 20);
    this.getTopData();
  },
  mounted() {
    this.getid = setInterval(() => {
      let getBox = document.getElementById("wxTable");
      if (getBox) {
        clearInterval(this.getid);
        this.getHotLineHeight(this.contentHeight, "wxTable", 35);
      }
    }, 500);
  },
  methods: {
    ...mapActions("hotList", ["AWeiXin"]),
    check(type) {
      if (type) {
        this.timeActive = type;
      }
    },
    async getTopData() {
      this.getData = [];
      this.loading = true;
      let result = await this.AWeiXin(Object.assign(this.pageable));
      if (result.errorCode === 0) {
        this.rowCount = result.data.rowCount;
        if (result.data.dataSource) {
          this.getData = result.data.dataSource;
        }
      } else {
        this.$message({ message: result.errorMess, type: "error" });
      }
      this.loading = false;
    },
    jump(guid) {
      this.$router.push("/article/detail/" + guid);
    },
    goPage(pageIndex) {
      this.pageable.pageIndex = pageIndex;
      this.getTopData();
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/style/color";
@import "../../assets/style/mixin";
.pageIndex();
.main {
  /*padding-right: 10px;*/
  width: 460px;
  font-size: 12px;
  .lineBox {
    height: 1px;
    border-top: 1px dashed #c3c3c3;
    background-color: #eee;
    flex: 1;
    /*margin-top: 10px;*/
  }
  .title-box {
    display: flex;
    text-align: left;
    margin: 15px 0;
    a {
      color: #5c5c5c;
    }
  }
  .listTable {
    height: 300px;
    width: 100%;
    overflow: auto;
    overscroll-behavior-y: contain;
    padding-right: 10px;
  }
  .main-box {
    display: flex;
    margin: 15px 0;
    div {
      &:nth-child(1) {
        img {
          width: 110px;
          height: 80px;
        }
        margin-right: 15px;
      }
    }
    .title {
      height: 63px;
      a {
        color: #5c5c5c;
      }
    }
    .user {
      float: left;
      color: #999;
      .head-img {
        width: 20px;
        height: 20px;
        float: left;
        border-radius: 50%;
        background: #ccc;
        margin-right: 8px;
        margin-top: -3px;
        img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
      }
    }
    .count {
      color: #999;
      float: right;
      div {
        display: inline-block;
        padding-left: 15px;
      }
    }
  }
  .hot-title {
    dl,
    dd {
      display: inline-block;
      margin-right: 10px;
    }
    dl {
      color: #99999c;
      dd {
        padding: 10px 10px;
        height: 25px;
        line-height: 3px;
        cursor: pointer;
      }
    }
    height: 35px;
    .active {
      background: #ebf3fe;
      border-radius: 20px;
      color: @theme-color;
      border: 1px solid #d9d9dc;
    }
  }
}
</style>
